import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import constants from '../../constants';
import { cookieStorageUtility } from '../../utils/utilityFunctions';
import { checkRole } from '../Common/CheckRole';
import { useNavigate } from 'react-router-dom';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const initialListData = {
  category_list: [],
  category_count: '',
  category_list_filter_data: {
    page: 1,
    limit: 10,
    total_pages: 0,
    category_name: ''
  },
  channel_list: [],
  channel_count: 0,
  channel_list_filter_data: {
    page: 1,
    limit: 10,
    total_pages: 0
  }
};

const initialSelected = {
  room_category_id: 0,
  channel_id: 0
};

const RoomCategoryListComponent = (props) => {
  const navigate = useNavigate();
  const [listData, setListData] = useState(initialListData);
  const [selected, setSelected] = useState(initialSelected);

  useEffect(() => {
    getCategoryListData();
    // eslint-disable-next-line
  }, []);

  const handleInputChange = (e, obj) => {
    const value = e.target.value;
    setListData(prev => {
      const newListData = { ...prev };
      newListData.category_list_filter_data = { ...prev.category_list_filter_data, [obj.name]: value, page: 1 };
      const categoryCount = getOccuranceCount(value, prev.category_list);
      newListData.category_list_filter_data.total_pages = Math.ceil(categoryCount / newListData.category_list_filter_data.limit);
      return newListData;
    });
  };

  const getOccuranceCount = (keyword, data) => {
    const filtered = getFilteredCateoryData(keyword, data);
    return filtered.length;
  };

  const getCategoryListData = () => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    props.setUILoaderVisibility(true);
    axios(serverUrl + 'category/roomcategorylist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { hotelId }
    })
      .then(response => {
        props.setUILoaderVisibility(false);
        if (response.data.status === 'success') {
          setListData(prev => {
            const newListData = { ...prev };
            newListData.category_list = response.data.data.category_data.list;
            newListData.category_count = response.data.data.category_data.total_count;
            newListData.category_list_filter_data = {
              ...prev.category_list_filter_data,
              total_pages: Math.ceil(response.data.data.category_data.total_count / prev.category_list_filter_data.limit)
            };
            newListData.channel_list = response.data.data.channel_data.list;
            newListData.channel_list_filter_data = {
              ...prev.channel_list_filter_data,
              total_pages: Math.ceil(response.data.data.channel_data.total_count / prev.channel_list_filter_data.limit)
            };
            newListData.channel_count = response.data.data.channel_data.total_count;
            return newListData;
          });
        } else {
          props.setNoticeMessage(response.data.message, 'error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const getFilteredCateoryData = (keyword, data) => {
    if (!data) data = listData.category_list;
    if (keyword === '') return data;
    return data.filter(l => l.room_category_name.toLowerCase().includes(keyword.toLowerCase()));
  };

  const categoryStatusUpdate = (room_category_id, action) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    props.setUILoaderVisibility(true);

    let requestType = action === 'active' ? 'active' : 'deactive';
    axios(serverUrl + 'category/changestatus', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        requestdata: {
          request_type: requestType,
          room_category_id: room_category_id
        }
      }
    })
      .then(response => {
        props.setUILoaderVisibility(false);
        if (response.data.status === 'success') {
          props.setNoticeMessage('Room Category status has been updated successfully', 'success');
          getCategoryListData();
        } else {
          props.setNoticeMessage(response.data.message, 'error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const categoryDelete = room_category_detail_id => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure, you want to delete this Room Category?')) {
      props.setUILoaderVisibility(true);

      axios(serverUrl + 'category/categorydelete', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: {
          hotelId,
          room_category_id: room_category_detail_id
        }
      })
        .then(response => {
          props.setUILoaderVisibility(false);

          if (response.data.status === 'success') {
            props.setNoticeMessage('Room Category has been removed successfully', 'success');
            getCategoryListData();
          } else {
            props.setNoticeMessage(response.data.message, 'error');
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  };

  const goToEditPage = (list, type) => {
    const { history } = props;

    if (typeof list === 'undefined') {
      navigate('/roomcategory/manage');
    } else {
      if (type === 'channel') {
        navigate('channelmanager/mychannels');
      } else {
        navigate('/roomcategory/manage/' + list.room_category_id);
      }
    }
  };

  const generateCategoryListHtml = () => {
    let page = listData.category_list_filter_data.page;
    let limit = listData.category_list_filter_data.limit;
    let offset = (page - 1) * limit;
    let categoryName = listData.category_list_filter_data.category_name;
    let data = getFilteredCateoryData(categoryName);
    return data.map((list, key) => {
      if (key >= offset && key < offset + limit) {
        return constuctCategoryListHtml(list, key);
      } else {
        return false;
      }
    });
  };

  const constuctCategoryListHtml = (list, key) => {
    return (
      <div className="col-xs-12 col-md-3 marg_bottom10 text-start" key={key}>
        <div className="cover bg1 shwd1 marg_bottom10">
          <div className="cover pad_top_bot7 pad_lft_rht10">
            <div className="cover">
              <div className="row gutters-5">
                <div className="col-xs-12 col-sm">
                  <div className="ovr bld tu marg_bottom10">
                    <span title="Category name">{list.room_category_name}</span>{' '}
                    <span title="Category code">{list.category_code ? '(' + list.category_code + ')' : ''}</span>
                  </div>
                </div>
                {checkRole('edit_room') ? (<React.Fragment>
                  {/* <div className="col-xs-auto " title="Edit" onClick={() => goToEditPage(list, 'category')}>
                    <i className="fa fa-pencil color7_2 fnt14"></i>
                  </div> */}
                  <div
                    className={`col-xs-auto ${list.status === 0 ? '' : 'hides'}`}
                    title="Deactive"
                  >
                    <i className="fa fa-shield color5_1 fnt14"></i>
                  </div>
                  <div
                    className={`col-xs-auto ${list.status === 1 ? '' : 'hides'}`}
                    title="Active"
                    >
                    <i className="fa fa-shield color4_1 fnt14"></i>
                  </div>
                </React.Fragment>) : ''}
              </div>
            </div>

            <div className="cover">
              <div className="row">
                <div className="col-xs-12 col-md-6 pad_top_bot3">
                  <div className="table_col table_fixed">
                    <div className="tabcel align_top">Rooms</div>
                    <div className="tabcel align_top wdhpx30 tr">{list.total_rooms}</div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-6 pad_top_bot3">
                  <div className="table_col table_fixed">
                    <div className="tabcel align_top">Occupancy</div>
                    <div className="tabcel align_top wdhpx30 tr">{list.base_occupancy}</div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-6 pad_top_bot3">
                  <div className="table_col table_fixed">
                    <div className="tabcel align_top">Extra Beds</div>
                    <div className="tabcel align_top wdhpx30 tr">{list.no_extra_bed}</div>
                  </div>
                </div>
                <div className="col-xs-12 col-md-6 pad_top_bot3">
                  <div className="table_col table_fixed">
                    <div className="tabcel align_top">Kids</div>
                    <div className="tabcel align_top wdhpx30 tr">{list.no_kid || 0}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ovr pad5 bg3"></div>
        </div>

        {list.channel_details !== null && generateCategoryListChannelHtml(list.channel_details, list.room_category_id)}
      </div>
    );
  };

  const generateCategoryListChannelHtml = (channel_details, room_category_id) => {
    return channel_details.map((list, key) => {
      return (
        <div className="cover marg_bottom10" key={key}>
          <div className="dropdown_wrapper ovr shwd1 bg1">
            <div
              className={`dropdownclick ovr pad_lft_rht10 pad_top_bot15 ${
                selected.room_category_id === room_category_id &&
                selected.channel_id === list.channel_id
                  ? 'bg7_2'
                  : ''
              }`}
              onClick={() => showHideRoomCategoryChannelDetails(list, room_category_id)}
            >
              <div className="row gutters-5">
                <div className="col-xs">
                  <div className="d-full-height justify-content-center pad_left10 color2_2">{list.channel_name}</div>
                </div>
                <div className="col-xs-auto">
                  <div className="d-full-height justify-content-center">
                    <div className="inline">
                      <div className="icon_size3 full-round bg7 color1">
                        <div className="icon_center"> {list.connected_rateplan_count} </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`dropdown_colum ovr ${
                selected.room_category_id === room_category_id &&
                selected.channel_id === list.channel_id
                  ? ''
                  : 'hides'
              }`}
            >
              {list.connected_rateplans.map((l, k) => {
                return (
                  <div className="cover pad10 border_all_1 border_color_1" key={k}>
                    <div
                      className="ovr color2_9 text_end"
                      title={`${l.rateplan_name} : ${l.mealplan_name}`}
                    >{`${l.rateplan_name} : ${l.mealplan_name}`}</div>
                    <div className="ovr color2_9 text_end">Rate Markup Flat : {l.markup_rate_flat}</div>
                    <div className="ovr color2_9 text_end">Rate Markup Percentage : {l.markup_rate_per}</div>
                    <div className="ovr color2_9 text_end">Mini Rate Threshold : {l.mini_rate_threshold}</div>
                    <div className="ovr color2_9 text_end">Decrease Inventory : {l.decrease_inventory}</div>

                    <div className="ovr color2_9 margtop8">{`${l.start_date} # ${l.end_date}`}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      );
    });
  };

  const generateChannelListHtml = () => {
    let page = listData.channel_list_filter_data.page;
    let offset = page - 1;

    return listData.channel_list.map((list, key) => {
      if (key === offset) {
        return (
          <React.Fragment key={key}>
            <div className="cover marg_bottom15" key={`${key}_one`}>
              <div className="row">
                <div
                  className={`col-xs-auto ${
                    listData.channel_list_filter_data.page === 1 ? 'color2_2' : 'cursor_p'
                  }`}
                  onClick={() => goPrevious('channel_list')}
                >
                  <i className="fa fa-chevron-left"></i>
                </div>
                <div className="col-xs fnt16 tc">{list.channel_name}</div>
                <div
                  className={`col-xs-auto ${
                    listData.channel_list_filter_data.page ===
                    listData.channel_list_filter_data.total_pages
                      ? 'color2_2'
                      : 'cursor_p'
                  }`}
                  onClick={() => goNext('channel_list')}
                >
                  <i className="fa fa-chevron-right"></i>
                </div>
              </div>
            </div>
            {typeof list.rateplan_details !== 'undefined' && generateChannelListMealplanDataHtml(list.rateplan_details)}
          </React.Fragment>
        );
      } else {
        return false;
      }
    });
  };

  const generateChannelListMealplanDataHtml = rateplan_details => {
    return rateplan_details.map((l, key) => {
      return (
        <React.Fragment key={`${key}_two`}>
          <div className="cover marg_bottom15 shwd1 bg1" key={`${key}_three`}>
            <div className="cover pad_top_bot10 pad_lft_rht15">
              <div
                className="ovr color2_9 pad_top_bot3"
                title={`${l.rateplan_name}${l.channel_rateplan_name ? `(${l.channel_rateplan_name})` : ''} : ${
                  l.mealplan_name
                }`}
              >{`${l.rateplan_name}${l.channel_rateplan_name ? `(${l.channel_rateplan_name})` : ''} : ${
                  l.mealplan_name
                }`}</div>
              <div className="ovr color2_9 pad_top_bot3">Rate Markup Flat : {l.markup_rate_flat}</div>
              <div className="ovr color2_9 pad_top_bot3">Rate Markup Percentage : {l.markup_rate_per}</div>
              <div className="ovr color2_9 pad_top_bot3">Mini Rate Threshold : {l.mini_rate_threshold}</div>
              <div className="ovr color2_9 pad_top_bot3">Decrease Inventory : {l.decrease_inventory}</div>

              <div className="ovr color2_9 pad_top_bot3">{`${l.start_date} # ${l.end_date}`}</div>
            </div>
          </div>
        </React.Fragment>
      );
    });
  };

  const goNext = type => {
    if (type === 'category_list') {
      setListData(prev => {
        const newListData = { ...prev };
        if (newListData.category_list_filter_data.page < newListData.category_list_filter_data.total_pages) {
          newListData.category_list_filter_data.page += 1;
        }
        return newListData;
      });
    } else if (type === 'channel_list') {
      setListData(prev => {
        const newListData = { ...prev };
        if (newListData.channel_list_filter_data.page < newListData.channel_list_filter_data.total_pages) {
          newListData.channel_list_filter_data.page += 1;
        }
        return newListData;
      });
    }
  };

  const goPrevious = type => {
    if (type === 'category_list') {
      setListData(prev => {
        const newListData = { ...prev };
        if (newListData.category_list_filter_data.page > 1) {
          newListData.category_list_filter_data.page -= 1;
        }
        return newListData;
      });
    } else if (type === 'channel_list') {
      setListData(prev => {
        const newListData = { ...prev };
        if (newListData.channel_list_filter_data.page > 1) {
          newListData.channel_list_filter_data.page -= 1;
        }
        return newListData;
      });
    }
  };

  const goTo = (type, page) => {
    if (type === 'category_list') {
      setListData(prev => {
        const newListData = { ...prev };
        newListData.category_list_filter_data.page = page;
        return newListData;
      });
    }
  };

  const showHideRoomCategoryChannelDetails = (list, roomCategoryId) => {
    setSelected(prev => {
      const newSelected = { ...prev };
      if (newSelected.room_category_id === roomCategoryId && newSelected.channel_id === list.channel_id) {
        newSelected.room_category_id = 0;
        newSelected.channel_id = 0;
      } else {
        newSelected.room_category_id = roomCategoryId;
        newSelected.channel_id = list.channel_id;
      }
      return newSelected;
    });
  };

  return (
    <React.Fragment>
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 marg_bottom20 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Category List</div>
          </div>

        </div>
      </div>
      <div className="container_fluid pad_lft_rht30 text-start">
        <div className="wrapper marg_bottom15">
          <div className="row">
            <div className="col-xs-12 col-md-10">
              <div className="wrapper pad_right25">
                <div className="cover">
                  <div className="row">
                    <div className="col-xs-12 col-sm-5 marg_bottom15">
                      <div className="frm border_all_1 border_color_1">
                        {' '}
                        <span className="fa_icon pad_lft_rht10">
                          <i className="fa fa-search"></i>
                        </span>
                        <input
                          placeholder="Search Category"
                          type="text"
                          className="input pad_lft_rht10"
                          value={listData.category_list_filter_data.category_name}
                          onChange={e => handleInputChange(e, { name: 'category_name' })}
                        />
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm marg_bottom15">
                      <div className="cover tr">
                        <div className="inline align_middle bg1 border_all_1 border_color_1 round3">
                          <div className="row no-gutters">
                            <div
                              className={`col-xs-auto border_r_1 border_color_1 ${
                                listData.category_list_filter_data.page === 1 ? 'color2_2' : 'cursor_p'
                              }`}
                              onClick={() => goTo('category_list', 1)}
                            >
                              <div className={'d-full-height justify-content-center pad_top_bot8 pad_lft_rht15'}>
                                {' '}
                                <i className="fa fa-angle-double-left fnt16"></i>
                              </div>
                            </div>
                            <div
                              className={`col-xs-auto border_r_1 border_color_1 ${
                                listData.category_list_filter_data.page > 1 ? 'cursor_p' : 'color2_2'
                              }`}
                              onClick={() => goPrevious('category_list')}
                            >
                              <div className="d-full-height justify-content-center pad_top_bot8 pad_lft_rht15">
                                {' '}
                                <i className="fa fa-chevron-left"></i>
                              </div>
                            </div>
                            <div className="col-xs-auto border_r_1 border_color_1">
                              <div className="d-full-height justify-content-center pad_top_bot8 pad_lft_rht15 bg3 color1">
                                {' '}
                                {listData.category_list_filter_data.page}
                              </div>
                            </div>
                            <div
                              className={`col-xs-auto border_r_1 border_color_1 ${
                                listData.category_list_filter_data.page <
                                listData.category_list_filter_data.total_pages
                                  ? 'cursor_p'
                                  : 'color2_2'
                              }`}
                              onClick={() => goNext('category_list')}
                            >
                              <div className="d-full-height justify-content-center pad_top_bot8 pad_lft_rht15">
                                {' '}
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </div>
                            <div
                              className={`col-xs-auto ${
                                listData.category_list_filter_data.page ===
                                listData.category_list_filter_data.total_pages
                                  ? 'color2_2'
                                  : 'cursor_p'
                              }`}
                              onClick={() =>
                                goTo('category_list', listData.category_list_filter_data.total_pages)
                              }
                            >
                              <div className={'d-full-height justify-content-center pad_top_bot8 pad_lft_rht15'}>
                                {' '}
                                <i className="fa fa-angle-double-right fnt16"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {listData.category_count !== '' && listData.category_count > 0 ? (
                  <div className="wrapper marg_bottom15">
                    <div className="row">{generateCategoryListHtml()}</div>
                  </div>
                ) : (
                  <div
                    className={`cover pad30 border_t_1 border_color_1 ${
                      listData.category_count === '' ? 'hides' : ''
                    }`}
                  >
                    <div className="ovr tc marg_bottom10">
                      <div className="inline">
                        <img src="images/no_result.png" alt="No Category Found" />
                      </div>
                    </div>
                    <div className="ovr tc fnt16 bld">No Category Found </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-xs-12 col-md-2">
              <div className="ovr color2_4  tr marg_bottom30 fnt18">
                {' '}
                Connected Channels : {listData.channel_count}
              </div>

              {generateChannelListHtml()}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RoomCategoryListComponent;
